// @generated by protoc-gen-es v2.12.0 with parameter "target=ts"
// @generated from file vision/shotlist/v1/delete_cast.proto (package protos.vision.shotlist.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file vision/shotlist/v1/delete_cast.proto.
 */
export const file_vision_shotlist_v1_delete_cast: GenFile = /*@__PURE__*/
  fileDesc("CiR2aXNpb24vc2hvdGxpc3QvdjEvZGVsZXRlX2Nhc3QucHJvdG8SGXByb3Rvcy52aXNpb24uc2hvdGxpc3QudjEihwEKEURlbGV0ZUNhc3RSZXF1ZXN0EkMKBnBhcmFtcxgBIAEoCzIzLnByb3Rvcy52aXNpb24uc2hvdGxpc3QudjEuRGVsZXRlQ2FzdFJlcXVlc3QuUGFyYW1zGi0KBlBhcmFtcxISCgpwcm9qZWN0X2lkGAEgASgJEg8KB2Nhc3RfaWQYAiABKAkiZAoSRGVsZXRlQ2FzdFJlc3BvbnNlEkQKBnJlc3VsdBgBIAEoCzI0LnByb3Rvcy52aXNpb24uc2hvdGxpc3QudjEuRGVsZXRlQ2FzdFJlc3BvbnNlLlJlc3VsdBoICgZSZXN1bHRiBnByb3RvMw");

/**
 * @generated from message protos.vision.shotlist.v1.DeleteCastRequest
 */
export type DeleteCastRequest = Message<"protos.vision.shotlist.v1.DeleteCastRequest"> & {
  /**
   * @generated from field: protos.vision.shotlist.v1.DeleteCastRequest.Params params = 1;
   */
  params?: DeleteCastRequest_Params | undefined;
};

/**
 * Describes the message protos.vision.shotlist.v1.DeleteCastRequest.
 * Use `create(DeleteCastRequestSchema)` to create a new message.
 */
export const DeleteCastRequestSchema: GenMessage<DeleteCastRequest> = /*@__PURE__*/
  messageDesc(file_vision_shotlist_v1_delete_cast, 0);

/**
 * @generated from message protos.vision.shotlist.v1.DeleteCastRequest.Params
 */
export type DeleteCastRequest_Params = Message<"protos.vision.shotlist.v1.DeleteCastRequest.Params"> & {
  /**
   * @generated from field: string project_id = 1;
   */
  projectId: string;

  /**
   * @generated from field: string cast_id = 2;
   */
  castId: string;
};

/**
 * Describes the message protos.vision.shotlist.v1.DeleteCastRequest.Params.
 * Use `create(DeleteCastRequest_ParamsSchema)` to create a new message.
 */
export const DeleteCastRequest_ParamsSchema: GenMessage<DeleteCastRequest_Params> = /*@__PURE__*/
  messageDesc(file_vision_shotlist_v1_delete_cast, 0, 0);

/**
 * @generated from message protos.vision.shotlist.v1.DeleteCastResponse
 */
export type DeleteCastResponse = Message<"protos.vision.shotlist.v1.DeleteCastResponse"> & {
  /**
   * @generated from field: protos.vision.shotlist.v1.DeleteCastResponse.Result result = 1;
   */
  result?: DeleteCastResponse_Result | undefined;
};

/**
 * Describes the message protos.vision.shotlist.v1.DeleteCastResponse.
 * Use `create(DeleteCastResponseSchema)` to create a new message.
 */
export const DeleteCastResponseSchema: GenMessage<DeleteCastResponse> = /*@__PURE__*/
  messageDesc(file_vision_shotlist_v1_delete_cast, 1);

/**
 * @generated from message protos.vision.shotlist.v1.DeleteCastResponse.Result
 */
export type DeleteCastResponse_Result = Message<"protos.vision.shotlist.v1.DeleteCastResponse.Result"> & {
};

/**
 * Describes the message protos.vision.shotlist.v1.DeleteCastResponse.Result.
 * Use `create(DeleteCastResponse_ResultSchema)` to create a new message.
 */
export const DeleteCastResponse_ResultSchema: GenMessage<DeleteCastResponse_Result> = /*@__PURE__*/
  messageDesc(file_vision_shotlist_v1_delete_cast, 1, 0);

